<template>
    <aside id="filter" class="ticketFilter">
        <div class="filterSections colorDeepGray">
            <span>ساعت پرواز</span>
            <div class="timesToChoose gridList3 colorDeepGray">
                <div  class="all" :class="{selected:localFilter.time=='all'}" @click="[localFilter.time='all']">
                    <p>همه</p>
                </div>
                <div  class="dawn" :class="{selected:localFilter.time=='0-6'}" @click="[localFilter.time='0-6']">
                    <span>سحر</span>
                    <span>۰ تا ۶</span>
                </div>
                <div  class="morning" :class="{selected:localFilter.time=='6-10'}" @click="[localFilter.time='6-10']">
                        <span>صبح</span>
                        <span>۶ تا ۱۰</span>
                </div>
                <div  class="noon" :class="{selected:localFilter.time=='10-14'}" @click="[localFilter.time='10-14']">
                        <span>ظهر</span>
                        <span>۱۰ تا ۱۴</span>
                </div>
                <div  class="afternoon" :class="{selected:localFilter.time=='14-18'}" @click="[localFilter.time='14-18']">
                        <span>عصر</span>
                        <span>۱۴ تا ۱۸</span>
                </div>
                <div  class="night" :class="{selected:localFilter.time=='18-24'}" @click="[localFilter.time='18-24']">
                        <span>شب</span>
                        <span>۱۸ تا ۲۴</span>
                </div>
            </div>
        </div>
        <div class="filterSections colorDeepGray">
            <span>کلاس صندلی</span>
            <div class="seatClass gridList3 colorDeepGray">
                <div class="allseats" :class="{selected:localFilter.seatClass=='allseats'}" @click="[localFilter.seatClass='allseats']">
                    <p>همه</p>
                </div>
                <div class="economy" :class="{selected:localFilter.seatClass=='economy'}" @click="[localFilter.seatClass='economy']">
                    <p>اکونومی</p>
                </div>
                <div class="business" :class="{selected:localFilter.seatClass=='business'}" @click="[localFilter.seatClass='business']">
                  <p>بیزینس</p>                    
                </div>
            </div>
        </div>
        <div class="filterSections colorDeepGray">
            <span>نوع بلیط</span>
            <div class="seatClass gridList3 colorDeepGray">
                <div class="all" :class="{selected:localFilter.charter=='allmodes'}" @click="[localFilter.charter='allmodes']">
                    <p>همه</p>
                </div>
                <div class="systemic" :class="{selected:localFilter.charter=='system'}" @click="[localFilter.charter='system']">
                  <p>سیستمی</p>
                </div>
                <div class="charter" :class="{selected:localFilter.charter=='charter'}" @click="[localFilter.charter='charter']">
                  <p>چارتر</p>                    
                </div>
            </div>
        </div>
    </aside>
</template>

<script>

export default {
    props:['localFilter'],
    data(){
        return{
            
        }
    },
    methods: {},
    components:{},
    watch:{
        localFilter:{
            deep:true,
            handler(filter){
                this.$emit('filter',filter)
            }
        }
    }
}
</script>

<style>

</style>
